import React from 'react';
import styles from './FrequentAddressSearchPanel.module.css';

var initialState = {
    fa_key: '',
    company: '',
    contact: '',
    address: '',
    suburb: '',
    account: ''
};

export default class FrequentAddressSearchPanel extends React.Component {
    constructor(props) {
        super(props);

        if (props.defaultAccount) {
            Object.assign(initialState, {
                account: props.defaultAccount
            });
        }

        this.state = initialState;

        this.resetForm = this.resetForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    resetForm() {
        this.setState(initialState);
    }

    handleChange(event) {

        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })

    }

    handleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(document.getElementById('frequentAddressQueryForm'));
        this.props.onFormSubmit(formData);
    }

    render() {

        var accountOptions = null;

        if (this.props.accountOptions !== undefined && this.props.accountOptions !== null) {
            var sortedAccounts = _.sortBy(this.props.accountOptions, ['label']);
            accountOptions = sortedAccounts.map(
                (a) => <option key={a.value} value={a.value}>{a.label}</option>
                );
        }

        return (
            <div id="frequentAddressSearchPanel">
                <form id="frequentAddressQueryForm" styleName="styles.form" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                                    <label>Account</label>
                                    <select className="form-control" name="account" value={this.state.account} onChange={this.handleChange}>
                                        {accountOptions}
                                    </select>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1">
                                    <div className="form-group">
                                        <label>Key</label>
                                        <input className="form-control" type="text" name="fa_key" value={this.state.fa_key} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                    <div className="form-group">
                                        <label>Company</label>
                                        <input className="form-control" type="text" name="company" value={this.state.company} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                                    <div className="form-group">
                                        <label>Contact</label>
                                        <input className="form-control" type="text" name="contact" value={this.state.contact} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label>Address</label>
                                        <input className="form-control" type="text" name="address" value={this.state.address} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label>Suburb</label>
                                        <input className="form-control" type="text" name="suburb" value={this.state.suburb} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                            <div styleName="styles.padding-label" />
                            <button type="submit" className="btn btn-default btn-dl-green">FIND ADDRESS</button>
                            <button type="button" className="btn btn-default btn-dl-green" onClick={this.resetForm}>CLEAR</button>
                        </div>
                    </div>
                </form>
                
            </div>
            )
    }
}